import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'containers.OrderPage.components.TaskPage.components.StartQualityCheck.title',
    defaultMessage: 'Start quality check',
  },
  cancel: {
    id: 'containers.OrderPage.components.TaskPage.components.StartQualityCheck.cancel',
    defaultMessage: 'Cancel',
  },
  loading: {
    id: 'containers.OrderPage.components.TaskPage.components.StartQualityCheck.loading',
    defaultMessage: 'Loading..',
  },
  submit: {
    id: 'containers.OrderPage.components.TaskPage.components.StartQualityCheck.submit',
    defaultMessage: 'Start',
  },
  sideEffects: {
    id: 'containers.OrderPage.components.TaskPage.components.StartQualityCheck.sideEffects',
    defaultMessage: `
      <li>- TODO</li>
      <li>- Prodction info here</li>
    `
  },
})
